import React from "react";

// Renders <a> only for https:// or mailto: URLs. Everything else becomes plain text.
export default function SafeLink({ href, children, ...rest }) {
  let safe = false;
  if (typeof href === "string" && href.length > 0 && href === href.trim()) {
    try {
      const u = new URL(href.trim());
      const proto = u.protocol.toLowerCase();
      if (proto === "https:" || proto === "mailto:") safe = true;
    } catch (_) { /* relative or malformed → not safe */ }
  }
  if (!safe) {
    return <span data-testid="assistant-rejected-link">{children}</span>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid="assistant-safe-link">
      {children}
    </a>
  );
}
